const ACTION = {
    UPDATE_VERIFY_CODE: 'UPDATE_VERIFY_CODE',
    UPDATE_DISABLE_BTN: 'UPDATE_DISABLE_BTN',
    UPDATE_VERIFY_INPUT_ERROR_TEXT: 'UPDATE_VERIFY_INPUT_ERROR_TEXT',
    UPDATE_VERIFY_PHONE_METHOD: 'UPDATE_VERIFY_PHONE_METHOD',
}

export default ACTION;